(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.trTR = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    el: {
      autocomplete: {
        noDataMessage: 'Hiçbir veri bulunamadı'
      },
      combobox: {
        placeholder: 'Seç',
        searchPlaceholder: 'Arama'
      },
      datepicker: {
        apply: 'Uygula',
        clearSelection: 'Temizle',
        pickADays: 'Günleri seçin',
        prevYear: 'Geçen Yıl',
        nextYear: 'Gelecek Yıl',
        prevMonth: 'Geçen Ay',
        nextMonth: 'Gelecek Ay',
        year: '',
        month1: 'Ocak',
        month2: 'Şubat',
        month3: 'Mart',
        month4: 'Nisan',
        month5: 'Mayıs',
        month6: 'Haziran',
        month7: 'Temmuz',
        month8: 'Ağustos',
        month9: 'Eylül',
        month10: 'Ekim',
        month11: 'Kasım',
        month12: 'Aralık',
        weeks: {
          sun: 'Paz',
          mon: 'Pzt',
          tue: 'Sal',
          wed: 'Çar',
          thu: 'Per',
          fri: 'Cum',
          sat: 'Cmt'
        },
        months: {
          jan: 'Oca',
          feb: 'Şub',
          mar: 'Mar',
          apr: 'Nis',
          may: 'May',
          jun: 'Haz',
          jul: 'Tem',
          aug: 'Ağu',
          sep: 'Eyl',
          oct: 'Eki',
          nov: 'Kas',
          dec: 'Ara'
        },
        pickADay: 'Bir gün seçin'
      },
      timepicker: {
        meridiemAM: 'ÖÖ',
        meridiemPM: 'ÖS'
      },
      dropdown: {
        noDataMessage: 'Hiçbir veri bulunamadı'
      },
      filepicker: {
        browse: 'Gözat',
        select: 'Bir dosya seçin'
      },
      filter: {
        apply: 'Uygula',
        cancel: 'İptal',
        filterButton: 'Filtrele',
        reset: 'Filtreleri sıfırla',
        resetDefault: 'Varsayılanlara sıfırla'
      },
      search: {
        noDataMessage: 'Hiçbir veri bulunamadı'
      },
      'multi-search': {
        'separator-and': 'VE',
        'search-button': 'Arama',
        'search-placeholder': 'Ada göre ara'
      },
      select: {
        all: 'Tümü',
        clearSelection: 'Bölümü temizle',
        noMatch: 'Hiçbir veri bulunamadı',
        noData: 'Veri yok',
        placeholder: 'Seç',
        item: 'öğe',
        selected: 'seçili',
        found: 'bulundu'
      },
      upload: {
        browseButton: 'Gözat',
        text: 'Yüklemek için dosyaları sürükleyip bırakın veya "Gözat" düğmesine tıklayın',
        tip: 'Her biri 25 MB\'ye kadar en fazla 10 dosya yükleyebilirsiniz'
      },
      table: {
        emptyText: 'Veri yok'
      },
      tree: {
        emptyText: 'Veri yok'
      }
    }
  };
  _exports.default = _default;
});